<template>
    <div class="hex-nav-container" :class="tabs.case_tpl_id + '_container'" ref="container">
        <div v-for="(item, index) in tabs.cate_list" :key="index"
            :class="activeIndex == index ? 'tabs tabActive' : 'tabs'" @click="tabChange(item, index)">
            <div v-if="tabs.case_tpl_id == 'case_1' || tabs.case_tpl_id == 'case_2' || tabs.case_tpl_id == 'case_5'"
                class="content" ref="scrollContainer" :class="tabs.case_tpl_id">
                <img :src="item.image" alt="" class="posImg">
            </div>
            <div v-else class="content" :class="tabs.case_tpl_id">
                <img v-if="activeIndex == index" :src="item.image" alt="" class="posImg">
                <img v-else :src="item.bg_image" alt="" class="posImg">
            </div>
            <div class="tab_text">
                {{ item.name }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NavTabs',
    props: {
        tabs: Object
    },
    data() {
        return {
            activeIndex: 0,
            isDragging: false, // 拖拽状态标志
            startX: 0,        // 拖拽起始位置X
            scrollLeft: 0,    // 初始滚动位置
        }
    },
    watch: {
    },
    mounted() {
        this.initDragScroll(); // 初始化拖拽滚动
    },
    beforeDestroy() {
        // 组件销毁前移除事件监听
        this.removeEventListeners();
    },
    created() {
        //监听左侧菜单传来的事件
        this.$bus.$on("send2index", (obj) => {
            this.$emit('tabChange', obj.name);
            this.activeIndex = obj.idx;
        });
    },
    methods: {
        // 初始化拖拽滚动功能
        initDragScroll() {
            const container = this.$refs.container;
            if (!container) return;

            // 鼠标事件监听
            container.addEventListener('mousedown', this.startDrag);
            container.addEventListener('mousemove', this.drag);
            container.addEventListener('mouseup', this.endDrag);
            container.addEventListener('mouseleave', this.endDrag);

            // 滚轮事件监听
            container.addEventListener('wheel', this.handleWheel, { passive: false });
        },
        // 移除事件监听
        removeEventListeners() {
            const container = this.$refs.container;
            if (!container) return;

            container.removeEventListener('mousedown', this.startDrag);
            container.removeEventListener('mousemove', this.drag);
            container.removeEventListener('mouseup', this.endDrag);
            container.removeEventListener('mouseleave', this.endDrag);
            container.removeEventListener('wheel', this.handleWheel);
        },
        // 开始拖拽
        startDrag(e) {
            this.isDragging = true;
            this.startX = e.pageX - this.$refs.container.offsetLeft;
            this.scrollLeft = this.$refs.container.scrollLeft;
            this.$refs.container.style.cursor = 'grabbing';
        },
        // 拖拽中
        drag(e) {
            if (!this.isDragging) return;
            e.preventDefault();
            const x = e.pageX - this.$refs.container.offsetLeft;
            const walk = (x - this.startX) * 2; // 滚动速度系数
            this.$refs.container.scrollLeft = this.scrollLeft - walk;
        },
        // 结束拖拽
        endDrag() {
            this.isDragging = false;
            this.$refs.container.style.cursor = 'grab';
        },
        // 处理滚轮滚动
        handleWheel(e) {
            // 阻止默认的垂直滚动，允许水平滚动
            if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
                this.$refs.container.scrollLeft += e.deltaY;
                e.preventDefault();
            }
        },
        tabChange(data, index) {
            this.activeIndex = index;
            if (this.tabs.case_tpl_id == 'case_2') {
                if (index != 0) {
                    this.$router.push(`/recente?cate_id=12&pid=${data.pid}&isHermes=true&index=${index - 1}`);
                } else {
                    this.$emit('tabChange', this.tabs.cate_list[this.activeIndex]);
                }

            } else if (this.tabs.case_tpl_id == 'case_5') {
                this.$router.push(`/recente?cate_id=${data.id}&flag=true&pid=${data.pid}`)
            } else {
                this.$emit('tabChange', this.tabs.cate_list[this.activeIndex]);
            }
        },
    }
}
</script>

<style lang="less" scoped>
@import "../assets/css/variables.less";

.content {
    position: relative;

    img {
        width: 100%;
        margin-top: .1rem;
        height: 0.8rem;
    }

    .posImg {
        width: 1.2rem;
    }
}

.hex-nav-container {
    position: relative;
    padding: 15px 15px;
    white-space: nowrap;
    width: 100%;
    overflow-x: auto;
    box-sizing: border-box;
    text-align: center;

    .notice {
        text-align: center;
        color: #fff0bb;
        margin-top: 20px;
        font-size: 14px;
    }
}

.hex-nav-container .tabActive {
    background-color: @anttextcolor;

    // 活跃状态的点击效果更强
    &:active {
        transform: translateY(5px) scale(0.96) !important;
        box-shadow: 0 0 .05rem 0 @primary-color !important;
        filter: brightness(0.85) !important;
    }

    &:hover {
        transform: translateY(3px) !important;
        box-shadow: 0 0 .3rem 0 @primary-color !important;
    }
}

c .tabActive .tab_text {
    color: @popupcolor;
}

.tabs .case_2 img {
    width: 0.8rem;
    height: 0.6rem;
}

.hex-nav-container.case_5_container {
    display: flex;
    padding: .1rem;
    box-sizing: border-box;
    justify-content: space-between;
    padding-left: .3rem;
    align-items: center;
    text-align: center;

    .tabs {
        background: none;
        transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
        transform: translateY(0);
        cursor: pointer;
        user-select: none;
        -webkit-user-select: none;
        -webkit-tap-highlight-color: transparent;

        .content {
            background: @tab-index-color;
            padding: 0.08rem .2rem;
            border-radius: .2rem;
            border: 1px solid @tab-border-color;
            margin-bottom: .2rem;
            transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);

            img {
                width: 0.7rem;
            }
        }

        .tab_text {
            color: @textcolor1;
            font-size: .35rem;
        }

        // 点击效果 - 向下沉
        &:active {
            transform: translateY(4px) scale(0.98);
            filter: brightness(0.9);

            .content {
                background: radial-gradient(circle, #3d287c 50%, #2a1e5a);
                border: 1px solid #4a3f7a;
            }
        }

        // 移动端触摸效果
        &:hover {
            transform: translateY(2px);

            .content {
                background: radial-gradient(circle, #4e3ea0 50%, #342668);
            }
        }
    }
}

.tabs {
    width: 22%;
    border: 1px solid @primary-color;
    box-shadow: 0 0 .3125rem 0 @primary-color;
    border-radius: 0.3rem;
    background-color: @bodercolor;
    margin: 0 auto;
    display: inline-block;
    margin-right: .15rem;
    padding: 3px 10px;
    // height: 2rem;
    text-align: center;
    box-sizing: border-box;
    transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateY(0);
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;

    .tab_text {
        color: #fff;
        font-size: .3rem;
        margin-top: .1rem;
    }

    // 点击效果 - 向下沉
    &:active {
        transform: translateY(4px) scale(0.98);
        box-shadow: 0 0 .1rem 0 @primary-color;
        filter: brightness(0.9);
    }

    // 移动端触摸效果
    &:hover {
        transform: translateY(2px);
        box-shadow: 0 0 .25rem 0 @primary-color;
    }
}

.hex-tabs {
    ::v-deep {
        .van-tabs__wrap {
            height: 100px;
            overflow: visible;
        }

        .van-tabs__nav {
            background: transparent;
            padding: 0 20px;
        }

        .van-tab {
            flex: 1;
            padding: 0 2px;
            overflow: visible;
        }
    }
}

.outer_regular_hexagon {
    position: absolute;
    z-index: 99;
    width: 200%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    clip-path: polygon(25% 0, 75% 0, 100% 50%, 75% 100%, 25% 100%, 0 50%);
    background-color: rgba(92, 123, 224, 0.8);
    transition: all 0.8s ease-in-out;

    .inner_regular_hexagon {
        display: grid;
        align-items: center;
        position: absolute;
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        clip-path: polygon(25% 0, 75% 0, 100% 50%, 75% 100%, 25% 100%, 0 50%);
        background-color: #fff;
        transition: all 0.3s ease-in-out;
        text-align: center;

        span {
            margin: auto;
        }
    }
}

.hex-nav-container .tabs .active {
    color: @activecolor;
}

.tabs .case_1 img {
    width: 0.8rem;
    height: 0.6rem;
}

.tabs .case_3 img {
    width: 1rem;
}

.case_1_container {
    display: flex;
    padding: 15px 0px;
}

.case_2_container {
    display: flex;
    padding: 15px 0px;
}

.tabs .case_4 img {
    width: 0.8rem;
    height: 0.6rem;
}

.hex-nav-container.case_4_container {
    display: flex;
    padding: 15px 0px;
}

.hex-nav-container.case_3_container {
    padding: 15px 0px;
    padding-left: .15rem;
}

.tabs .case_3 img {
    width: 0.8rem;
    height: 0.8rem;
}
</style>